/**
 * Centralized API base resolver.
 *
 * Why:
 * - Some deployments serve the React app on a "portal-*" domain, while the API runs elsewhere.
 * - Falling back to window.location.origin causes /api/* calls to hit the portal domain, which can 503 if no backend is attached.
 */

const normalizeBaseUrl = (baseUrl) => {
  if (!baseUrl) return "";
  try {
    const url = new URL(baseUrl);
    // Prevent browser mixed-content blocking when UI is loaded via HTTPS.
    if (typeof window !== "undefined" && window.location.protocol === "https:" && url.protocol === "http:") {
      url.protocol = "https:";
    }
    return url.origin;
  } catch (_) {
    return String(baseUrl).replace(/\/+$/, "");
  }
};

export const getApiBase = () => {
  const envBase = process.env.REACT_APP_API_BASE;
  if (envBase) return normalizeBaseUrl(envBase);

  const host = window.location.hostname;

  // Deployment-specific overrides
  const hostMap = {
    "portal-orange.rprprime.com": "https://paidwifi.rprprime.com",
  };

  const mapped = hostMap[host];
  if (mapped) return normalizeBaseUrl(mapped);

  return normalizeBaseUrl(window.location.origin);
};

export default getApiBase;

